"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.numberParecent = void 0;
const numberRound_1 = require("./numberRound");
/**
 * obliczanie wartości procentowej
 * @param value wartość
 * @param totalValue wartośc odpowiadająca 100%
 */
function numberParecent(value, totalValue) {
    if (totalValue === 0) {
        return 0;
    }
    else {
        const result = (value * 100) / totalValue;
        return result < 0 ? 0 : (0, numberRound_1.numberRound)(result, 8);
    }
}
exports.numberParecent = numberParecent;
//# sourceMappingURL=numberPercent.js.map